<style scoped>
.hidden {
  display: none;
}

.blur-behind {
  backdrop-filter: blur(10px);
}

.margin-adder {
  margin: 20px;
}
</style>

<template>
  <v-container
      align-center
      fluid
    >
      <v-layout justify-space-around>
        <a
          ref="hiddenDownloadLink"
          target="_blank"
          class="hidden"
          :download=fileName
          :href=finalBlob
        ></a>

        <v-card
          v-on:click = mux
          max-width="360px"
          min-width="360px"
          target="_blank"
          :download=fileName
          :hover=true
          :href=finalBlob
          :disabled=this.processing
        >
          <div v-if=this.processing>
            <v-row align-content="center">
              <v-col cols="2" align-self="center">
                <v-progress-circular
                left
                x-large
                color="#2e9ae4"
                class="margin-adder"
                indeterminate
                ></v-progress-circular>
              </v-col>
              <v-col>
                <v-card-title>{{downloadProgress}}%</v-card-title>
                <v-card-subtitle>Processing...</v-card-subtitle>
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <v-row align-content="center">
              <v-col cols="2" align-self="center">
                <v-icon
                x-large
                color="#f78d00"
                class="margin-adder"
                >download_for_offline</v-icon>
              </v-col>
              <v-col>
                  <v-card-title>Download Video with Audio</v-card-title>
                  <v-card-subtitle>Click to download...</v-card-subtitle>
              </v-col>
            </v-row>
          </div>
        </v-card>

        <video-processor
          v-if="this.files.length==2"
          :videoFile=files[0]
          :audioFile=files[1]
          :onFinish=showDownload
        >
        </video-processor>
      </v-layout>
  </v-container>
</template>

<script>
  import fetchProgress from 'fetch-progress';
  /* eslint-disable no-unused-vars */
  var Blob = require('blob-polyfill').Blob;
  const videoProcessor = () => import('./VideoProcessor.vue')

  export default {
    props: {
      audio_url: String,
      video_url: String,
      image_url: String,
    },
    data: () => ({
      processing: false,
      audioTransfered: 0,
      videoTransfered: 0,
      audioSize: 1,
      videoSize: 1,
      files: [],
      finalBlob: "",
      fileName: "Untitled [www.reddit.watch].mp4",
    }),
    computed: {
      downloadProgress: function(){
        var totalTransfered = this.audioTransfered+this.videoTransfered
        var totalSize = this.audioSize+this.videoSize
        var progress = (totalTransfered/totalSize)*100
        return Math.floor(progress)
      }
    },
    components: {
      "video-processor": videoProcessor,
    },
    methods: {
      mux: function() {
        //No-op if finalBlob already exists.
        if (this.finalBlob.length!=0) {return}
        this.fileName = this.getFileName()
        this.processing = true
        this.color = "secondary"
        Promise.all([this.fetchVideo(this.video_url), this.fetchAudio(this.audio_url)])
          .then(function(){
          }.bind(this))
      },
      fetchAudio: function(audio_url) {
        const that = this
        fetch(audio_url)
        .then(
          fetchProgress({
            onProgress(progress) {
              that.audioSize = progress.total
              that.audioTransfered = progress.transferred
            },
          })
        )
        .then(function(response) {
          return  response.blob()
        }).then(function(audio_blob) {
          this.files.push(new File([audio_blob], "audio.mp4"))
        }.bind(this))
      },
      fetchVideo: function(video_url) {
        const that = this
        fetch(video_url)
        .then(
          fetchProgress({
            onProgress(progress) {
              that.videoSize = progress.total
              that.videoTransfered = progress.transferred
            },
          })
        )
        .then(function(response) {
          return  response.blob()
        }).then(function(video_blob) {
          this.files.push(new File([video_blob], "video.mp4"))
        }.bind(this))
      },
      showDownload: function(url) {
        this.finalBlob = url
        this.processing = false

        // Don't wait for Vue render, manually update the href on the hidden URL
        this.$refs.hiddenDownloadLink.href = url
        this.$refs.hiddenDownloadLink.click()

        this.$router.replace("/thanks")
      },
      getFileName: function () {
        let randNumber = Math.floor(Math.random() * (9999 - 1000)) + 1000
        return "Video "+randNumber+" [www.reddit.watch].mp4"
      },
    },
  };
</script>